import LanguageDetector from 'i18next-browser-languagedetector';
import 'intl-pluralrules';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 导入语言资源
import enTrans from './react-i18next/en.json';
import zhCnTrans from './react-i18next/zh-cn.json';
import thTrans from './react-i18next/th.json';
import zhTwTrans from './react-i18next/zh-tw.json';
import idTrans from './react-i18next/id.json';
import msTrans from './react-i18next/ms.json';
import jaTrans from './react-i18next/ja.json';
import koTrans from './react-i18next/ko.json';
import ptTrans from './react-i18next/pt.json';
import esTrans from './react-i18next/es.json';
import arTrans from './react-i18next/ar.json';
import viTrans from './react-i18next/vi.json';

// 语言资源映射
const resources = {
  en: { translation: enTrans },
  zhCn: { translation: zhCnTrans },
  zhTw: { translation: zhTwTrans },
  th: { translation: thTrans },
  id: { translation: idTrans },
  ms: { translation: msTrans },
  ja: { translation: jaTrans },
  ko: { translation: koTrans },
  pt: { translation: ptTrans },
  es: { translation: esTrans },
  ar: { translation: arTrans },
  vi: { translation: viTrans },
};

// 初始化 i18n
i18n
  .use(LanguageDetector) // 嗅探当前浏览器语言
  .use(initReactI18next) // 初始化 i18next
  .init({
    compatibilityJSON: 'v3',
    resources,
    fallbackLng: 'en', // 默认语言
    debug: false,
    interpolation: {
      escapeValue: false, // React 默认处理转义
    },
  });

export default i18n;
